module.exports = __webpack_public_path__ + "img/main_bg@2x.9214f792.png";